// Based on https://github.com/leny/react-use-storage
import usePersistentState from '../usePersistentState.js';
import storage from './index.js';

function useStorage(key, defaultValue) {
  return usePersistentState(storage, key, defaultValue);
}

export default useStorage;
